// extracted by mini-css-extract-plugin
module.exports = {"callPhoneNumber":"CallPhoneNumber_callPhoneNumber__1SZHG","r":"CallPhoneNumber_r__2vKSn","seconds":"CallPhoneNumber_seconds__2DHVI"};